import script from "./LeftSideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftSideBar.vue?vue&type=script&setup=true&lang=js"

import "./LeftSideBar.vue?vue&type=style&index=0&id=3a7c4378&scoped=true&lang=css"

import exportComponent from "/Users/aakash/Documents/projects/portfoilio-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a7c4378"]])

export default __exports__